import api from './api';

export async function purchaseGiftCard(transaction) {
    if (!transaction.order) return {};

    try {
        const { data } = await api.post(`orders/confirm`, transaction);
        if (data) return data;
    } catch (err) {
        throw err;
    }
}

export async function fetchOrderSituation(order) {
    if (!order) return {};

    const { data } = await api.get(`orders/${order}`);

    if (data) return data;
}
